// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"00f1574b","149":"da23941b","205":"693e27e1","337":"c697742b","411":"4068dbfe","430":"7e65cd78","838":"b69f23da","891":"905dfb92","921":"db472c00","976":"348ade81","986":"324d8e16"}[chunkId] + ".chunk.js";
};